import React, {Component} from 'react'
import {Provider, connect } from 'react-redux'
import  ProductOptionsContainer from '../containers/product_options_container'

import ReduxStore from '../reducers/product_option_store'
const store = ReduxStore();

export default class ProductOptionsRoot extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    // get the options from the server, tell the store
    jQuery.get("/rmrc_ad/products/" + this.props.product_id + "/options.json", function(data){
      store.dispatch({type: "LOAD_PRODUCT_OPTIONS", initialState: {options:data} });
    })

  }

  render(){
    return (
      <Provider store={store}>
      <ProductOptionsContainer />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/roots/product_options_root.jsx